module.exports = __webpack_public_path__ + "assets/ic-uniswap.a2d4620f.svg";